import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Button } from 'components/Button';

export interface MergeDialogProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onReplace: () => void;
  onMerge: () => void;
  filterSetName: string;
}

export function MergeDialog({ open, onClose, onCancel, onReplace, onMerge, filterSetName }: MergeDialogProps) {
  const handleReplace = () => {
    onReplace();
    onClose();
  };

  const handleMerge = () => {
    onMerge();
    onClose();
  };

  const handleCancel = (_event: object, reason?: string) => {
    if (reason === 'backdropClick') return;
    onCancel();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      aria-labelledby="filter-merge-dialog-title"
      aria-describedby="filter-merge-dialog-description"
    >
      <DialogTitle id="filter-merge-dialog-title">
        <div className="flex items-center justify-between w-full">
          <h4 className="text-[18px]">
            <FormattedMessage id="advanced-filter-set-merge-dialog.title" defaultMessage="Apply Selection?" />
          </h4>
          <Button aria-label="close" onClick={onClose} className="ml-auto" tabIndex={0} icon="Cross" />
        </div>
      </DialogTitle>
      <DialogContent id="filter-merge-dialog-description" className="flex justify-center">
        <p className="text-base">
          <FormattedMessage
            id="advanced-filter-set-merge-dialog.message"
            defaultMessage="Do you want to add these filters to your active selection or replace it entirely?"
            values={{ name: filterSetName }}
          />
        </p>
      </DialogContent>
      <DialogActions>
        <div className="flex justify-between w-full items-center">
          <Button id="merge-filter-set-cancel-button" priority="secondary" onClick={handleCancel}>
            <FormattedMessage id="general.button.cancel" defaultMessage="Cancel" />
          </Button>
          <div className="flex gap-2">
            <Button id="merge-filter-set-replace-button" priority="ternery" onClick={handleReplace}>
              <FormattedMessage id="general.button.replace" defaultMessage="Replace" />
            </Button>
            <Button id="merge-filter-set-add-button" onClick={handleMerge}>
              <FormattedMessage id="general.button.add" defaultMessage="Add" />
            </Button>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}
